import { axios } from "../../../lib"

export const deleteArticleRule = (id) => {
    return axios.delete(`/nomenclatures/rules/article/${id}`)
}